import { IonAccordion, IonAccordionGroup, IonListHeader, IonList, IonToast, IonGrid, IonBadge, IonCardContent, IonCard, IonButton, useIonRouter, IonChip, IonToolbar, IonText, IonAvatar, IonCol, IonIcon, IonImg, IonItem, IonLabel, IonNote, IonRow, IonThumbnail, IonRippleEffect } from '@ionic/react';
import { locationOutline, chatboxOutline, heartCircleOutline, heartOutline, chatbubbleEllipses, earth, heart, heartCircle } from 'ionicons/icons';
import { ContentInfo, ContentInterface, ContentUpdateInt } from '../data/item';
import React, { Component, useState }  from 'react';

// import Swiper core and required modules
import SwiperCore, { Virtual, Zoom, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import "swiper/css/zoom";
import 'swiper/css/pagination';
import 'swiper/css/navigation';

import NServer, { UIElement, RegisterAppServices, handleRouteError } from "../components/NServer";
import Vault from '../components/Vault';
import { showAlert } from '../components/Alert';

import UserBar from '../components/UserBar'; 
import LikeBar from '../components/LikeBar'; 
import ActionComp from '../components/ActionComp'; 
import { LANGUAGE, GetStr } from "../language/Language";
import { ReadyAds, ShowAds } from "../components/Admob";

import '../pages/Main.css'; 

  
const MarketItem : React.FC<ContentUpdateInt> = ({ content, index, onUpdate, view, autoplay }) => {
    
    const [msgSent, setMsgSent] = useState(false);
    const [showMsgSent, setShowMsgSent] = useState(false);

    const router = useIonRouter();

    // print money
    const money = (n : any) => {
        let x = "" + n;
        return x.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    // click on content
    const showContent = async (id : string) => {
        let ready = await ReadyAds();
        if (!ready)
            router.push("/market/" + id + "/n", "forward", "push");
        else
        {
            ShowAds( () => {
                router.push("/market/" + id + "/ad", "forward", "push");
            });
        }
    }

    // send message to seller
    const sendMessage = async () => {
        // send the message
        let v = new Vault();
        await v.read();

        let msg = GetStr(LANGUAGE.TXT_MK_INTERESTED_MSG);

        const state = {
            id: v.account.id,
            pass: v.account.key,
            to: content.user,
            msg: msg,
            content: content.id
        }

		var server = new NServer();
        await server.sendForm("nc_send_msg_market", state);

        if (!server.success && server.message != "")
            showAlert(server.message);
        else
        {
            setMsgSent(true);
            setShowMsgSent(true);   
        }
    }

    // click on the image
    const clickImage = (index : number) => {
        // only work in full mode
        if (view == "full")
        {
            let img = "";
            if (index < content.images.length)
                img = content.images[index];
            if (img == "")
                return;

            router.push("/imgviewer/" + encodeURIComponent(img) + "/" + (index) + "/" + content.id + "/content", 
                "forward", "push");
        }
    }

    return (
        <div>
        {
            view == "full" ?
        <div>
            {
                content.type == "vidfile" ?
            <div>
                {
                    content.images.length > 0 ?
                <video className="html-video-player" loop={false} autoPlay controls>
                    <source src={ content.images[0] } />
                    Your browser does not support the video tag.
                </video>
                    :
                <div className="video-error-view">
                    <i>{ GetStr(LANGUAGE.TXT_VIDEO_CONTENT_ERROR) }</i>
                </div>
                }
                </div>
                :
                content.type == "video" ?
            <div>
                {
                    content.images.length > 0 ?
                <iframe 
                    className="video-player"
                    src={"https://www.youtube.com/embed/" +  content.images[0] + "?autoplay=" + (autoplay ? 1 : 0) + "&rel=0"} 
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" 
                    allowFullScreen
                    frameBorder="0"
                />
                    :
                <div className="video-error-view">
                    <i>{ GetStr(LANGUAGE.TXT_VIDEO_CONTENT_ERROR) }</i>
                </div>
                }
            </div>
                :
                content.type == "image" ?
            <Swiper
                className="market-img-wrapper"
                slidesPerView={1}
                spaceBetween={0}
                pagination={true}
                modules={[Pagination]}
                virtual
            >
            {
                content.images.map( (m, index) => (
                <SwiperSlide key={index} virtualIndex={index}>
                    <div className="swiper-zoom-container" onClick={ ()=> clickImage(index) }>
                        <img className="market-img"
                            src={ m } 
                            onError={ ({currentTarget}) => { currentTarget.src = '/assets/img/shop_avt.jpg' } }/>
                    </div>
                </SwiperSlide>
                ))
            }
            </Swiper>
            :
            <div/>
            }
            <div className="ion-padding-start ion-padding-end">
                <h1>{ content.title }</h1>
            </div>
            <div className="ion-padding-start ion-padding-end ion-padding-bottom">
                <b>{ GetStr(LANGUAGE.TXT_MARKET_PRICE) }{ money(content.action) + " " + content.action_lbl }</b>
            </div>
            <div className="ion-padding-start ion-padding-end">
                { content.desc }
            </div>
            <div className="ion-padding-start ion-padding-end ion-padding-top">
                <small>{ GetStr(LANGUAGE.TXT_MK_POSTED_BY) }</small>
            </div>
            <div>
                <UserBar content={content} index={index} onUpdate={onUpdate} view={view} autoplay={autoplay} />
            </div>
            <div>
                <IonCard className="flat-card bk round-card">
                    <IonCardContent>
                        <IonGrid className="full-width ion-padding">
                            <IonRow>
                                <IonCol className="right-avt-pad">
                                    <div className="msg-right">
                                        <IonBadge className="msg msg-text">
                                            { GetStr(LANGUAGE.TXT_MK_INTERESTED_MSG) }
                                        </IonBadge>
                                    </div>
                                    <div className="timestamp ion-text-right" >
                                        now
                                    </div>
                                </IonCol>
                                <IonCol className="avt-col">
                                    <IonAvatar className="avt-size">
                                        <img src="/assets/img/avt.jpg" />
                                    </IonAvatar>
                                </IonCol>
                            </IonRow>
                        </IonGrid>
                        <IonButton className="main-but act-but" expand="block" onClick={sendMessage} disabled={msgSent}>
                            { GetStr(LANGUAGE.TXT_MK_INTERESTED_SEND) }
                        </IonButton>
                    </IonCardContent>
                </IonCard>
            </div>
            <div>
                <IonCard className="flat-card bk round-card">
                     <IonAccordionGroup value="main">
                        <IonAccordion value="main">
                            <IonItem slot="header" color="light">
                                <IonLabel>{ GetStr(LANGUAGE.TXT_MK_AVAIL_LOC) }</IonLabel>
                            </IonItem>
                            {
                                content.react_comments.map( (e, index) => (
                            <IonItem key={index} slot="content" lines="full">
                                <IonIcon slot="start" icon={locationOutline} />
                                { e }
                            </IonItem>
                            ))}
                        </IonAccordion>
                    </IonAccordionGroup>
                </IonCard>
            </div>
            <div>
                <LikeBar content={content} index={index} onUpdate={onUpdate} view="market" autoplay={autoplay} />
            </div>
        </div>
            :
        <div className="market-div-wrapper">
            {
                content.react_comments[0] != "" ?
            <IonCard className="market-item market-div flat-card ion-activatable ripple-parent"
                onClick={ ()=> showContent(content.react_comments[0]) }>
                <IonImg className="market-item-img" src={ content.images[0] } />
                <div className="market-item-title">
                    <b>{ GetStr(LANGUAGE.TXT_MARKET_PRICE) }{ money(content.likes) + " " + content.action }</b> - { content.supporters[0] }
                </div>
                <IonRippleEffect></IonRippleEffect>
            </IonCard>
                :
            <div/>
            }

            {
                content.react_comments[1] != "" ?
            <IonCard className="market-item market-div flat-card ion-activatable ripple-parent"
                onClick={ ()=> showContent(content.react_comments[1]) }>
                <IonImg className="market-item-img" src={ content.images[1] } />
                <div className="market-item-title">
                    <b>{ GetStr(LANGUAGE.TXT_MARKET_PRICE) }{ money(content.comments) + " " + content.action_lbl }</b> - { content.supporters[1] }
                </div>
                <IonRippleEffect></IonRippleEffect>
            </IonCard>
                :
            <div/>
            }
        </div>
        }

            <IonToast
                isOpen={showMsgSent}
                onDidDismiss={() => setShowMsgSent(false)}
                message={ GetStr(LANGUAGE.TXT_MK_MSG_SENT) }
                position="bottom"
                duration={5000}
                buttons={[
                  {
                    text: 'X',
                    role: 'cancel',
                    handler: () => {
                        setShowMsgSent(false);
                    }
                  }
                ]}
              />
        </div>
    );
};
  
export default MarketItem;